var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('svg',{attrs:{"width":"8","height":"8","viewBox":"0 0 8 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"4","cy":"4","r":"4","fill":_vm.fill}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }